var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import { GridContainerTitle } from './styles/gridTitle.styled';
const GridTitle = (_a) => {
    var { children, class: className } = _a, attributes = __rest(_a, ["children", "class"]);
    const gridTitleClassNames = classNames('PONCHO-grid__title', className);
    return (_jsx(GridContainerTitle, Object.assign({ className: gridTitleClassNames, variant: "content-title" }, attributes, { children: children })));
};
GridTitle.GRID_ELEMENT = 'GRID_TITLE';
export default GridTitle;
